<template>
  <v-app-bar height="60" dense elevation="0" fixed app clipped-left>
    <v-toolbar-title class="mr-3">
      <router-link to="/" tag="span" class="header-logo">
        <img
          alt="logo"
          class="text-center d-flex align-center"
          src="@/assets/images/logo.svg"
        />
      </router-link>
    </v-toolbar-title>
    <p
      v-if="$vuetify.breakpoint.mdAndUp"
      class="font-weight-bold mt-auto mb-3 header-date-now"
    >
      {{ getDateNow }}
    </p>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="authUser">
      <div class="d-flex align-center">
        <div class="d-none align-center font-weight-bold d-md-block">
          <div class="px-3" v-if="authUser.role">
            <span class="role">{{ authUser.role.name }}</span>
          </div>
        </div>
        <div class="separator mx-2 d-none d-md-block"></div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              text
              class="letter-space-none text-none px-3"
              v-bind="attrs"
              v-on="on"
            >
              {{ authUser.name }}
              <v-icon right color="primary">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link>
              <v-list-item-title @click="logout"
                >Cerrar sesión
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import moment from "moment";
import crudServiceMixin from "../../mixins/crudServiceMixin";
import sessionMixin from "@/mixins/sessionMixin";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  data() {
    return {};
  },
  props: {
    sidebar: {
      type: Boolean,
    },
  },
  computed: {
    authUser() {
      return this.getAuthUser();
    },
    getDateNow() {
      moment.locale("es");
      const dateNow = Date.now();
      const day = moment(dateNow).format("dddd D");
      const monthYear = moment(dateNow).format("MMM YYYY");
      return `${day.replace(/^./, day[0].toUpperCase())} de ${monthYear}`;
    },
  },
  mixins: [crudServiceMixin, sessionMixin],
  methods: {
    async logout() {
      this.clear();
      this.$router.push({ path: "/" });
    },
  },
};
</script>
<style lang="scss">
.role {
  font-family: "Inter-Black", sans-serif;
  font-size: 14px;
  color: #fb8501;
}

.separator {
  border-right: 1px solid #000;
  width: 1px;
  height: 20px;
}

.header-date-now {
  font-size: 13px;
}

.header-logo {
  cursor: pointer;

  img {
    width: 110px;
  }
}
</style>
